import type { ComponentProps } from "react";
import { cn } from "@/lib/utils";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

type Props = Pick<
  ComponentProps<typeof SelectTrigger>,
  "id" | "disabled" | "aria-invalid" | "aria-describedby" | "className"
> & {
  value: string;
  onValueChange: (value: string) => void;
  options: { value: string; label: string; disabled?: boolean }[];
  placeholder?: string;
};

export function FieldSelect({
  value,
  onValueChange,
  options,
  placeholder,
  disabled,
  className,
  ...triggerProps
}: Props) {
  return (
    <Select value={value} onValueChange={onValueChange} disabled={disabled}>
      <SelectTrigger
        {...triggerProps}
        className={cn("revy-ui gap-2 bg-card [&>span]:min-w-0 [&>svg]:shrink-0", className)}
      >
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      {/* Track the trigger while its parent dialog scales into view. */}
      <SelectContent
        updatePositionStrategy="always"
        className="revy-ui w-[var(--radix-select-trigger-width)] max-w-[var(--radix-select-content-available-width)] [&_[data-radix-select-viewport]]:min-w-0"
      >
        {options.map((option) => (
          <SelectItem
            key={option.value}
            value={option.value}
            disabled={option.disabled}
            className="whitespace-normal [overflow-wrap:anywhere]"
          >
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
